import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { authOperations } from "../../../redux/auth";
import { configOperations } from "../../../redux/config";

import Checkbox from 'material-ui/Checkbox';
import Paper from 'material-ui/Paper';
import ArrowRightIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
//import WarnIcon from 'material-ui/svg-icons/alert/warning';
import GridIcon from 'material-ui/svg-icons/image/grid-on';

import { getNameForCategory, belowUniquenessThreshold } from '../../../utils/incidentHelper';

import originFields from '../../../defaults/PointOfOriginFields.json'


import './IncidentListItem.css';
import theme from '../../../muiTheme';

const checkboxStyle = {marginRight: 0, textAlign: 'left', fill: theme.palette.canvasColor};

class IncidentListItem extends Component {

  render() {
    const attrs = this.props.incident.attributes;
    const acres = attrs[originFields.incidentSize];
    const isQuarantined = attrs[originFields.isQuarantined];
    const incidentIsCertified = this.props.incident.attributes[originFields.statusId] === 3;
    const incidentIsComplete = this.props.incident.attributes[originFields.statusId] === 1;
    const isBelowUniquenessThreshold = belowUniquenessThreshold(this.props.incident);

  let statusColor;
   if (incidentIsCertified)
   {
     statusColor = theme.palette.primary2Color
   }
   else if (incidentIsComplete)
   {
     statusColor = theme.palette.primary1Color
   }
   else if (isQuarantined)
   {
     statusColor = theme.palette.accent2Color
   }
   else if (isQuarantined)
   {
     statusColor = theme.palette.accent2Color
   }
   else if (isBelowUniquenessThreshold)
   {
     statusColor = theme.palette.nonUniqueColor
   }
   else
   {
     statusColor = theme.palette.secondaryTextColor
   }

    return (
      <Paper
        onMouseEnter={() => this.props.onMouseEnter(this.props.incident)}
        onMouseLeave={() => this.props.onMouseExit(this.props.incident)}
        onClick={() => this.props.onClicked(this.props.incident, isQuarantined)}
        className={"incident-list-item"}
        >
        <div className="incident-list-item-content">
          <div className="incident-list-item-main-content">
            <div className="list-item-status-container" style={{backgroundColor: statusColor}}>
              <Checkbox
                iconStyle={checkboxStyle}
                checked={this.props.isChecked}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.onChecked(this.props.incident)
                }} />
            </div>

            <div className="list-item-details-container">
              <div className="list-item-detail-group">
                <div className="list-item-field-group">
                  <label>Incident Name</label>
                  <p className="list-item-incident-name">{attrs[originFields.name] || "––"}</p>
                </div>
                <div className="list-item-field-group">
                  <label>{getNameForCategory(attrs[originFields.incidentTypeCategory])}</label>
                </div>
                <div className="list-item-field-group">
                  <label>ID</label>
                  <p className="list-item-detail-label">{attrs[originFields.uniqueFireId] || "––"}</p>
                </div>
              </div>
              <div className="list-item-detail-group">
                <div className="list-item-field-group">
                  <label>Fire Size</label>
                  <p>{acres ? parseFloat(acres).toLocaleString() : "––"}</p>
                </div>
                <div className="list-item-field-group">
                  <label>FireCode</label>
                  <p>{attrs[originFields.fireCode] || "––"}</p>
                </div>
              </div>
              <div className="list-item-detail-group">
                <div className="list-item-field-group">
                  <label>Discovery</label>
                  <p>{attrs[originFields.discoveryDate] ? moment(attrs[originFields.discoveryDate]).format(this.props.appConfig.dateFormat) : "––"}</p>
                </div>
                <div className="list-item-field-group">
                  <label>Fire Out</label>
                  <p>{attrs[originFields.outDate] ? moment(attrs[originFields.outDate]).format(this.props.appConfig.dateFormat) : "––"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="list-item-inspect-container" title={attrs[originFields.name] || "––"}>
              <Checkbox
              checkedIcon={<ArrowRightIcon />}
              uncheckedIcon={<GridIcon />}
              checked={true}
              iconStyle={{fill: theme.palette.secondaryTextColor, marginRight: 0}} />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  appConfig: state.config
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...authOperations,
    ...configOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IncidentListItem)
